import React from 'react';
import ReportIcon from '@material-ui/icons/Report';

import { translate } from 'services/i18nService';
import styles from 'components/DesktopBroadcastKickedState/DesktopBroadcastKickedState.css';


const DesktopBroadcastBannedState = () => (
  <div className={styles.kickedVideoWrapper}>
    <ReportIcon classes={{ root: styles.reportIcon }} fontSize="large" />
    <p className={styles.reportText}>{translate('v2profile.banned.message')}</p>
  </div>
);

export default DesktopBroadcastBannedState;
